var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardHero',{attrs:{"loading":_vm.loading},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Revenue:")]},proxy:true},{key:"value",fn:function(){return [_vm._v("\n    "+_vm._s(_vm._f("currencySign")(_vm.data.billedAmount,_vm.$root.state.facilityData))+"\n  ")]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7393b48c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FacilityRevenue.vue
// module id = null
// module chunks = 